import accountComponent from './my-account.component';
import accountRoutes from './my-account.routes';

export default angular
  .module('fizyweb.paycell.myAccount', [])
  .component('fizyPaycellMyAccount', accountComponent)
  .config(accountRoutes).name;



// WEBPACK FOOTER //
// src/app/my-account/my-account.module.ts